<section
  class="page page-not-found d-flex justify-content-center align-items-center"
>
  <p class="font-24 font-primary--b opacity-25">
    {{ "shared-pages.not-found.title" | translate }}
  </p>
  <button class="mt-3 btn bg-blue" routerLink="/dashboard">
    <span class="text-white font-primary--b font-14">
      {{ "shared-pages.not-found.button" | translate }}
    </span>
  </button>
</section>
